<script setup lang="ts">
import { useStore } from 'vuex';

import ApplePayButton from '@/components/cart/ApplePayButton.vue';
import PaypalButton from '@/components/cart/PaypalButton.vue';
import ShopPayButton from '@/components/cart/ShopPayButton.vue';
import { ExpressLocation, useExpressCheckout } from '@/composables/useExpressCheckout';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

defineProps<{
  trackingEventLocation: ExpressLocation;
}>();

const { flags } = useFeatureFlags();
const store = useStore();
const { offerExpressCheckout, offerShopPay } = useExpressCheckout(store);

const buttonHeight = 48;
</script>

<template>
  <transition name="fade">
    <div v-if="offerExpressCheckout" data-test="express-checkout">
      <div
        class="relative w-full py-2 text-xs text-center"
        :class="{ 'hidden md:block md:visible': flags.cartLayoutUpdates }"
        data-test="divider"
      >
        <span class="mx-2 font-extrabold text-gray-500">or check out quickly with</span>
      </div>
      <div class="flex flex-row gap-1 md:flex-col">
        <ApplePayButton
          :style="`height: ${buttonHeight}px`"
          :componentName="trackingEventLocation"
          expressCheckout
        />
        <PaypalButton :buttonHeight :trackingEventLocation />
        <ShopPayButton v-if="offerShopPay" :tracking-event-location />
      </div>
      <p
        class="mt-4 text-xs text-gray-500"
        :class="{ 'hidden md:block md:visible': flags.cartLayoutUpdates }"
        data-test="disclaimer"
      >
        *Gift options, multiple addresses and other features are unavailable with express checkout
      </p>
    </div>
  </transition>
</template>
